"use client";
import { Field, Input, Select, Textarea } from "@/components/ui";
import { ActionForm, SubmitButton, type FormAction } from "@/components/ui/client";

export function ContactForm({ action, signedInEmail }: { action: FormAction; signedInEmail?: string | null }) {
  return (
    <ActionForm action={action} resetOnSuccess className="space-y-5">
      {(s) => (
        <>
          <div className="grid gap-5 sm:grid-cols-2">
            <Field label="Your name" htmlFor="c-name" optional>
              <Input id="c-name" name="name" autoComplete="name" maxLength={120} />
            </Field>
            {signedInEmail ? (
              <Field label="Email" htmlFor="c-email" hint="We'll reply to your account email.">
                <Input id="c-email" value={signedInEmail} disabled readOnly />
              </Field>
            ) : (
              <Field label="Email" htmlFor="c-email" error={s.fieldErrors?.email}>
                <Input id="c-email" name="email" type="email" autoComplete="email" required aria-invalid={!!s.fieldErrors?.email} />
              </Field>
            )}
          </div>
          <Field label="Topic" htmlFor="c-category">
            <Select id="c-category" name="category" defaultValue="general">
              <option value="general">General question</option>
              <option value="billing">Plans & billing</option>
              <option value="payments">Payments</option>
              <option value="domains">Domains</option>
              <option value="technical">Technical problem</option>
              <option value="account">My account / signing in</option>
            </Select>
          </Field>
          <Field label="Subject" htmlFor="c-subject" error={s.fieldErrors?.subject}>
            <Input id="c-subject" name="subject" required minLength={3} maxLength={150} aria-invalid={!!s.fieldErrors?.subject} />
          </Field>
          <Field label="Message" htmlFor="c-message" error={s.fieldErrors?.message}>
            <Textarea id="c-message" name="message" required minLength={10} maxLength={10000} rows={6} aria-invalid={!!s.fieldErrors?.message} />
          </Field>
          <div aria-hidden className="hidden">
            <label>
              Website
              <input name="website" tabIndex={-1} autoComplete="off" />
            </label>
          </div>
          <p className="text-xs text-zinc-500">Please don&apos;t include passwords, API keys or full card numbers in your message.</p>
          <SubmitButton size="lg" pendingText="Sending…">
            Send message
          </SubmitButton>
        </>
      )}
    </ActionForm>
  );
}
